import React, { Component, Fragment } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Switch, Route, Redirect } from "react-router-dom";
import { TopToolBar } from "./TopToolBar";
import Header from "./Header";
import { Breadcrumb } from "./Breadcrumb";
import { Footer } from "./Footer";
import { UEInfo } from "./UEInfo";
import { HamburgerMenuOffices } from "./HamburgerMenuOffices";
import { default as Index } from "./Index";
import { NavMenu } from "./NavMenu";
import { RouteUrls } from "../configs/routeUrls";
import { AppActionCreators, UserActionCreators } from "../actions";
import {
  Consultation,
  LoginForm,
  Probe,
  Survey,
  SearchList,
  Initiative,
  Budget,
  TermsOfUseCard,
} from "./projects";
import { InitiativeMode } from "../utils/enums";
import LegalDocumentContainer from "./LegalDocumentContainer";
import { RedirectComponentCallback } from "./RedirectCallbackComponent";
import IFrameComponent from "./IFrame";

class Layout extends Component {
  constructor() {
    super();

    this.state = {
      hamburgerMenu: "",
    };

    this.openOffices = () => {
      this.setState({
        hamburgerMenu: this.state.hamburgerMenu === "offices" ? "" : "offices",
      });
    };

    this.openMenu = () => {
      this.setState({
        hamburgerMenu: this.state.hamburgerMenu === "menu" ? "" : "menu",
      });
    };
    this.checkLoginInterval = null;
  }

  componentDidMount() {
    this.props.getInitData();
    this.props.getApplicationImages();

    if (this.props.user) {
      this.props.initialLoginUser(this.props.location.pathname);
    }
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.pathname !== this.props.pathname &&
      this.props.pathname === RouteUrls.App.main
    ) {
      this.props.setBreadcrumbs([]);
    }
    if (prevProps.user !== this.props.user && this.props.user) {
      this.props.initialLoginUser(this.props.location.pathname);
    }
  }

  render() {
    const { hamburgerMenu } = this.state;
    const {
      isAuth,
      initiativeMode,
      applicationImages,
      breadcrumbs,
      setBreadcrumbs,
      appVersion,
      appModule,
      appModuleFetched,
      legalDocument,
      eformExternalServiceAddress,
    } = this.props;

    return (
      <Fragment>
        <Switch>
          <Route
            exact
            path={RouteUrls.App.redirectUri}
            component={RedirectComponentCallback}
          />
          <div>
            <TopToolBar {...this.props} />
            <NavMenu
              {...this.props}
              openOffices={this.openOffices}
              openMenu={this.openMenu}
              onSearchProject={(value) =>
                this.props.searchProject({ ...value, size: 10 })
              }
              isSearching={this.props.isSearching}
              display={hamburgerMenu === "menu" ? "block" : "none"}
              eformExternalServiceAddress={eformExternalServiceAddress}
            />
            <Header {...this.props} />
            <Breadcrumb {...this.props} items={breadcrumbs} />
            <HamburgerMenuOffices
              {...this.props}
              display={hamburgerMenu === "offices" ? "block" : "none"}
            />
            <main>{this.props.children}</main>
            <Switch>
              <Route exact path={RouteUrls.App.main} component={Index} />
              <Route
                exact
                path={RouteUrls.App.login}
                render={() => (
                  <LoginForm
                    {...this.props}
                    onSetBreadcrumbs={setBreadcrumbs}
                  />
                )}
              />
              {appModule.consultation && (
                <Route
                  path={RouteUrls.Consultation.default}
                  component={Consultation}
                />
              )}
              {appModule.consultation && (
                <Route
                  path={RouteUrls.Consultation.list.actual}
                  component={Consultation}
                />
              )}
              {appModule.consultation && (
                <Route
                  path={RouteUrls.Consultation.list.finished}
                  component={Consultation}
                />
              )}
              {appModule.probe && (
                <Route path={RouteUrls.Probe.default} component={Probe} />
              )}
              {appModule.probe && (
                <Route path={RouteUrls.Probe.list.actual} component={Probe} />
              )}
              {appModule.probe && (
                <Route path={RouteUrls.Probe.list.finished} component={Probe} />
              )}
              {appModule.survey && (
                <Route path={RouteUrls.Survey.default} component={Survey} />
              )}
              {appModule.survey && (
                <Route path={RouteUrls.Survey.list.actual} component={Survey} />
              )}
              {appModule.survey && (
                <Route
                  path={RouteUrls.Survey.list.finished}
                  component={Survey}
                />
              )}
              {appModule.budget && (
                <Route path={RouteUrls.Budget.default} component={Budget} />
              )}
              {appModule.budget && (
                <Route path={RouteUrls.Budget.list.actual} component={Budget} />
              )}
              {appModule.budget && (
                <Route
                  path={RouteUrls.Budget.list.finished}
                  component={Budget}
                />
              )}
              {(appModule.consultation || appModule.budget) &&
                (initiativeMode !== InitiativeMode.Hidden || isAuth) && (
                  <Route
                    path={RouteUrls.Initiative.default}
                    component={Initiative}
                  />
                )}
              <Route path={RouteUrls.App.searchList} component={SearchList} />
              <Route
                path={`${RouteUrls.App.termOfUse}/:id`}
                component={TermsOfUseCard}
              />
              <Route
                path={RouteUrls.App.legalDocument}
                component={LegalDocumentContainer}
              />
              {appModuleFetched ? (
                <Redirect to={RouteUrls.App.notFound} />
              ) : null}
            </Switch>
            <Footer
              officeFooter={this.props.officeFooter}
              applicationImages={applicationImages}
            />
            <UEInfo
              officeFooter={this.props.officeFooter}
              applicationImages={applicationImages}
              appVersion={appVersion}
              legalDocument={legalDocument}
            />
          </div>
        </Switch>
        {appModuleFetched ? <IFrameComponent /> : null}
      </Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    isAuth: state.app.isAuth,
    loggedUser: state.app.loggedUser,
    externalSystemAddress: state.app.externalSystemAddress,
    offices: state.app.offices,
    officeFooter: state.app.officeFooter,
    initiativeMode:
      state.app.initiativeConfiguration.mode || InitiativeMode.Hidden,
    isSearching: state.app.isSearching,
    isLoging: state.app.isLoging,
    applicationImages: state.app.applicationImages,
    breadcrumbs: state.app.breadcrumbs,
    appVersion: state.app.appVersion,
    pathname: state.routing.location?.pathname || null,
    appModule: state.app.appModule || {
      consultation: false,
      budget: false,
      probe: false,
      survey: false,
    },
    appModuleFetched: state.app.appModuleFetched,
    legalDocument: state.app.legalDocument,
    helpPageData: state.app.helpPageData,
    // serverIdentity: state.app.serverIdentity || {
    //   authority: "",
    //   client_id: "",
    //   scope: "asw-api",
    // },
    user: state.oidc && state.oidc.user ? state.oidc.user : null,
    topMenuElements: state.app.topMenuElements || [],
    tiles: state.app.tiles || [],
    eformExternalServiceAddress: state.app.eformExternalServiceAddress || "",
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return bindActionCreators(
    { ...AppActionCreators, ...UserActionCreators },
    dispatch
  );
};
export default connect(mapStateToProps, mapDispatchToProps)(Layout);

// export default Layout;
